import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";
import logo from "@/assets/logo-allepets.png";

export function Footer() {
  return (
    <footer className="border-t bg-muted/50 py-12">
      <div className="container">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-8">
          <div className="col-span-2 md:col-span-1">
            <img 
              src={logo} 
              alt="AllePets" 
              className="h-10 mb-4 hover:scale-105 transition-transform duration-300" 
            />
            <p className="text-sm text-muted-foreground">
              Conexão entre pets e hospedagens. Encontre o lar temporário perfeito para seu melhor amigo.
            </p>
          </div>

          <div>
            <h4 className="font-semibold mb-4">Para tutores</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              {["Buscar hospedagem", "Como funciona", "Segurança", "Avaliações"].map((item) => (
                <li key={item}>
                  <Link 
                    to="/" 
                    className={cn(
                      "relative inline-block transition-colors hover:text-foreground",
                      "after:content-[''] after:absolute after:w-full after:scale-x-0 after:h-0.5",
                      "after:bottom-0 after:left-0 after:bg-forest after:origin-bottom-right",
                      "after:transition-transform after:duration-300",
                      "hover:after:scale-x-100 hover:after:origin-bottom-left"
                    )}
                  >
                    {item}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4">Para anfitriões</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              {["Seja um anfitrião", "Quanto posso ganhar", "Requisitos", "Recursos"].map((item) => (
                <li key={item}>
                  <Link 
                    to="/anfitrioes" 
                    className={cn(
                      "relative inline-block transition-colors hover:text-foreground",
                      "after:content-[''] after:absolute after:w-full after:scale-x-0 after:h-0.5",
                      "after:bottom-0 after:left-0 after:bg-forest after:origin-bottom-right",
                      "after:transition-transform after:duration-300",
                      "hover:after:scale-x-100 hover:after:origin-bottom-left"
                    )}
                  >
                    {item}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4">Suporte</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              {["Central de ajuda", "Contato", "Termos de uso", "Privacidade"].map((item) => (
                <li key={item}>
                  <Link 
                    to="/" 
                    className={cn(
                      "relative inline-block transition-colors hover:text-foreground",
                      "after:content-[''] after:absolute after:w-full after:scale-x-0 after:h-0.5",
                      "after:bottom-0 after:left-0 after:bg-forest after:origin-bottom-right",
                      "after:transition-transform after:duration-300",
                      "hover:after:scale-x-100 hover:after:origin-bottom-left"
                    )}
                  >
                    {item}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-muted-foreground">
            © 2026 AllePets®. Todos os direitos reservados.
          </p>
          <div className="flex gap-4">
            {["Instagram", "Facebook", "WhatsApp"].map((social) => (
              <span
                key={social}
                className={cn(
                  "text-muted-foreground/70 cursor-not-allowed",
                  "transition-colors duration-300"
                )}
                aria-disabled="true"
              >
                {social}
              </span>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
